import CustomerEventsHtml from './customer.events.html';

export function CustomerEventsDirective () {
  return {
    controller: 'CustomerEventsCtrl',
    restrict: 'E',
    templateUrl: CustomerEventsHtml,
    scope: {
      customer: '=',
      events: '='
    }
  }
}
